/**
 * Kumo Discount Preview
 * 自动识别折扣码并在产品页展示折后价
 * 折扣码通过 /discount/CODE 链接激活
 */
(function () {
  'use strict';

  // ─── 工具函数 ────────────────────────────────────────────────────

  /**
   * 格式化金额（分 → 带符号字符串）
   * 优先使用 Shopify 原生 formatMoney，降级到自定义实现
   */
  function formatMoney(cents, format) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, format);
    }
    var moneyFormat = format || window.KumoDiscountConfig.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return moneyFormat.replace('{{amount}}', amount)
                      .replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }

  /**
   * 读取 cookie 值
   */
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  // ─── 核心：获取当前激活的折扣码 ──────────────────────────────────

  function getActiveDiscountCode() {
    // 1. URL 路径 /discount/CODE（访问折扣链接时）
    var pathMatch = window.location.pathname.match(/\/discount\/([^/?]+)/i);
    if (pathMatch) {
      var code = pathMatch[1].toUpperCase();
      try { localStorage.setItem('kumo_discount_code', code); } catch (e) {}
      return code;
    }

    // 2. URL 参数 ?discount=CODE
    var params = new URLSearchParams(window.location.search);
    var paramCode = params.get('discount');
    if (paramCode) {
      var upper = paramCode.toUpperCase();
      try { localStorage.setItem('kumo_discount_code', upper); } catch (e) {}
      return upper;
    }

    // 3. localStorage（上次访问折扣链接后持久保存）
    try {
      var stored = localStorage.getItem('kumo_discount_code');
      if (stored) return stored;
    } catch (e) {}

    // 4. Shopify 原生折扣 cookie（/discount/CODE 访问后由 Shopify 写入）
    var cookieCode = getCookie('discount_code') || getCookie('_discount_code');
    if (cookieCode) return cookieCode.toUpperCase();

    return null;
  }

  // ─── 价格 DOM 更新 ────────────────────────────────────────────────

  /**
   * 常见 Shopify 主题的价格选择器，按优先级排列
   * 如主题有自定义结构，在 KumoDiscountConfig.priceSelector 中指定
   */
  var PRICE_SELECTORS = [
    '[data-product-price]',
    '.product__price .price-item--regular',
    '.product__price .price__regular .price-item',
    '.price__regular',
    '.product-single__price',
    '.product__price',
    '#ProductPrice',
    '.current-price',
  ];

  var COMPARE_SELECTORS = [
    '[data-compare-price]',
    '.price__compare .price-item',
    '.price-item--sale',
    '.was-price',
    '#ComparePrice',
  ];

  /**
   * 找到页面上第一个匹配的价格元素
   */
  function findElement(selectors, scope) {
    var root = scope || document;
    for (var i = 0; i < selectors.length; i++) {
      var el = root.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  /**
   * 向页面注入折扣价格展示
   * @param {number} originalCents  原价（分）
   * @param {number} discountedCents 折后价（分）
   * @param {string} discountLabel  折扣标签，如 "10% OFF"
   */
  function renderDiscountPrice(originalCents, discountedCents, discountLabel) {
    var config = window.KumoDiscountConfig || {};
    var container = document.querySelector(config.mountSelector || '.kumo-discount-price-wrap');

    // 若无挂载点，自动插入到原价之后
    if (!container) {
      var priceEl = findElement(config.priceSelectors || PRICE_SELECTORS);
      if (!priceEl) return;

      container = document.createElement('div');
      container.className = 'kumo-discount-price-wrap';
      priceEl.parentNode.insertBefore(container, priceEl.nextSibling);
    }

    container.innerHTML =
      '<div class="kumo-discount-block" aria-label="' + discountLabel + '">' +
        '<span class="kumo-original-price">' + formatMoney(originalCents) + '</span>' +
        '<span class="kumo-discounted-price">' + formatMoney(discountedCents) + '</span>' +
        '<span class="kumo-discount-badge">' + discountLabel + '</span>' +
      '</div>';

    container.style.display = '';
  }

  /**
   * 清除折扣展示（如折扣码失效或切换到不参与折扣的 variant）
   */
  function clearDiscountPrice() {
    var container = document.querySelector('.kumo-discount-price-wrap');
    if (container) container.style.display = 'none';
  }

  // ─── 主逻辑 ───────────────────────────────────────────────────────

  function applyDiscountPreview(priceInCents) {
    var config = window.KumoDiscountConfig || {};
    var discountCode = getActiveDiscountCode();

    if (!discountCode) {
      clearDiscountPrice();
      return;
    }

    // 从配置中查找折扣百分比，支持大小写不敏感
    var discounts = config.discounts || {};
    var percent = discounts[discountCode] || discounts[discountCode.toLowerCase()] || null;

    if (!percent || percent <= 0 || percent >= 100) {
      clearDiscountPrice();
      return;
    }

    var discountedCents = Math.round(priceInCents * (1 - percent / 100));
    var label = percent + '% OFF';
    renderDiscountPrice(priceInCents, discountedCents, label);
  }

  /**
   * 监听 variant 切换事件（Shopify 标准事件 + 常见主题自定义事件）
   */
  function listenVariantChange() {
    // Shopify 原生 variant:changed 事件（部分主题）
    document.addEventListener('variant:changed', function (e) {
      var variant = e.detail && e.detail.variant;
      if (variant && variant.price) {
        applyDiscountPreview(variant.price);
      }
    });

    // Dawn / 新主题 custom event
    document.addEventListener('product-variant-change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (variant && variant.price) {
        applyDiscountPreview(variant.price);
      }
    });

    // 监听 URL 变化（部分 SPA 结构主题）
    var lastUrl = location.href;
    new MutationObserver(function () {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        init();
      }
    }).observe(document.body, { subtree: true, childList: true });
  }

  /**
   * 从页面读取当前产品价格（分）
   * 优先读 data-product-price 属性（已是分的整数），降级读文本解析
   */
  function readCurrentPrice() {
    var config = window.KumoDiscountConfig || {};

    // 方式 1：JSON 格式的产品数据（最可靠）
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) {
      var meta = window.ShopifyAnalytics.meta;
      if (meta.product && meta.product.price) return parseInt(meta.product.price, 10);
    }

    // 方式 2：data 属性
    var selectors = config.priceSelectors || PRICE_SELECTORS;
    var el = findElement(selectors);
    if (el) {
      var dataPrice = el.getAttribute('data-product-price') || el.getAttribute('data-price');
      if (dataPrice) return parseInt(dataPrice, 10);

      // 方式 3：文本内容（去掉符号后乘以 100）
      var text = el.textContent.replace(/[^0-9.]/g, '');
      if (text) return Math.round(parseFloat(text) * 100);
    }

    return null;
  }

  function init() {
    var price = readCurrentPrice();
    if (price) {
      applyDiscountPreview(price);
    }
    listenVariantChange();
  }

  // DOM 就绪后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();